import script from "./System.vue?vue&type=script&setup=true&lang=js"
export * from "./System.vue?vue&type=script&setup=true&lang=js"

import "./System.vue?vue&type=style&index=0&id=624a8001&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-624a8001"]])

export default __exports__